/**
 * Tickets-Fixtures spiegeln die Live-Shape aus
 * 02_applications/02_orbit.valitype.com/backend/api-design.md.
 *
 * Status-Werte, Reply-Kinds und Cursor-Schema sind identisch zur Backend-API
 * damit Fixture- und Live-Mode dieselben UI-Komponenten füttern.
 */

const TICKETS = [
  {
    id: 9001,
    ticketNumber: 'VKY-2026-0042',
    subject: 'DKIM funktioniert nicht',
    status: 'open',
    priority: 'normal',
    channel: 'manual',
    customer: { id: 4711, email: 'customer@example.com', displayName: 'Erika M.' },
    assignedTo: null,
    createdAt: '2026-06-14T13:00:00.000Z',
    createdBy: { id: 4321, displayName: 'Tobias K.' },
    lastActivityAt: '2026-06-14T13:00:00.000Z',
  },
  {
    id: 9002,
    ticketNumber: 'VKY-2026-0043',
    subject: 'Mailbox-Quota Erhöhung',
    status: 'pending',
    priority: 'low',
    channel: 'email',
    customer: { id: 4712, email: 'kunde@beispiel.de', displayName: 'Max P.' },
    assignedTo: { id: 4321, displayName: 'Tobias K.' },
    createdAt: '2026-06-14T08:15:00.000Z',
    createdBy: { id: 4321, displayName: 'Tobias K.' },
    lastActivityAt: '2026-06-14T11:42:00.000Z',
  },
  {
    id: 9003,
    ticketNumber: 'VKY-2026-0040',
    subject: 'SSL-Zertifikat läuft ab',
    status: 'resolved',
    priority: 'high',
    channel: 'manual',
    customer: { id: 4713, email: 'admin@kunde.net', displayName: 'Sabine R.' },
    assignedTo: { id: 4322, displayName: 'Alice W.' },
    createdAt: '2026-06-12T09:00:00.000Z',
    createdBy: { id: 4322, displayName: 'Alice W.' },
    lastActivityAt: '2026-06-13T17:24:00.000Z',
  },
];

function matchesStatusFilter(t, status) {
  if (!status || status === 'all') return true;
  const allowed = status.split(',').map((s) => s.trim()).filter(Boolean);
  return allowed.length === 0 || allowed.includes(t.status);
}

export function ticketsListFixture({ status = 'open,pending', priority = '', search = '' } = {}) {
  let list = TICKETS.filter((t) => matchesStatusFilter(t, status));
  if (priority) {
    const allow = priority.split(',').map((s) => s.trim());
    list = list.filter((t) => allow.includes(t.priority));
  }
  if (search) {
    const needle = search.toLowerCase();
    list = list.filter(
      (t) =>
        t.subject.toLowerCase().includes(needle) ||
        t.ticketNumber.toLowerCase().includes(needle) ||
        t.customer.email.toLowerCase().includes(needle),
    );
  }
  return { items: list, nextCursor: null, totalApprox: list.length };
}

export function ticketDetailFixture(idOrNumber) {
  const key = String(idOrNumber);
  const ticket =
    TICKETS.find((t) => String(t.id) === key || t.ticketNumber === key) ?? TICKETS[0];
  return {
    ticket,
    replies: [
      {
        id: 12001,
        kind: 'customer_reply',
        body: 'Unser DKIM-Selector validiert nicht — siehe Log im Anhang.',
        authorOperatorId: null,
        authorCustomerEmail: ticket.customer.email,
        createdAt: ticket.createdAt,
        attachments: [{ id: 30001, filename: 'setup.log', size: 24_576 }],
      },
      {
        id: 12002,
        kind: 'operator_reply',
        body: 'Hallo, wir schauen uns den Selector an — Rückmeldung in ~15 Min.',
        authorOperatorId: 4321,
        authorCustomerEmail: null,
        createdAt: new Date(Date.parse(ticket.createdAt) + 90_000).toISOString(),
        attachments: [],
      },
      {
        id: 12003,
        kind: 'operator_note',
        body: 'Re-Sync mit Enhance läuft, ggf. erneut anfragen wenn nicht binnen 30 Min.',
        authorOperatorId: 4321,
        authorCustomerEmail: null,
        createdAt: new Date(Date.parse(ticket.createdAt) + 150_000).toISOString(),
        attachments: [],
      },
    ],
    audit: [
      {
        at: ticket.createdAt,
        actor: { id: 4321, displayName: 'Tobias K.' },
        action: 'ticket.created',
      },
    ],
  };
}

export function uploadAttachmentFixture(file) {
  return {
    attachment: {
      id: Date.now(),
      filename: file?.name ?? 'upload.bin',
      size: file?.size ?? 0,
      mimeType: file?.type ?? 'application/octet-stream',
    },
  };
}

export function attachmentUrlFixture(id, attId) {
  const expires = new Date(Date.now() + 15 * 60_000).toISOString();
  return {
    url: `https://s3.example.test/tickets/${id}/${attId}?X-Amz-Signature=fixture`,
    expiresAt: expires,
  };
}
